import { useClient, useDictionary } from "@adamlip/okeoke.client"
import Icon from "assets/icons"
import { MainContext } from "contexts/MainContext"
import { UserContext } from "contexts/UserContext"
import useStorage from "hooks/useStorage"
import { useContext, useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import needLogin from "utils/NeedLogin-v1"
import LoginModal from "views/Login"
import MoreMenu from "views/MoreMenu"
import { Modal, ModalBody, ModalContent } from "@nextui-org/react"
import { AppParamsContext } from "contexts/AppParamsContext"

export default function NavIcon({ element }) {
  const location = useLocation()
  const navigate = useNavigate()
  const { getValue } = useDictionary()
  const { getName } = useClient()
  const { getSV } = useStorage()
  const { appParams } = useContext(AppParamsContext)
  const { userData, userLoggedIn } = useContext(UserContext)
  const { handlePingLogin } = useContext(MainContext)

  const [loginModal, setLoginModal] = useState(false)

  const [selected, setSelected] = useState(false)
  const [disabled, setDisabled] = useState(true)

  const [modalContent, setModalContent] = useState(false)
  const [modalOpen, setModalOpen] = useState(false)

  const { path, icon, text, multiLangText, customColor } = element || {}

  const style =
    customColor != null && !selected ? { background: customColor } : {}

  const handleModalOpen = (content) => {
    switch (content) {
      case "moreModal":
        setModalContent(<MoreMenu onSelect={() => setModalOpen(false)} />)
        break
      default:
        setModalContent(null)
    }
    if (modalContent) setModalOpen(true)
  }

  const handleElementAction = (action) => {
    switch (action?.type) {
      case "openModal":
        handleModalOpen(action.content)
        break
      default:
        navigate(path)
    }
  }

  const handleClickOnNavIcon = () => {
    if (disabled) {
      handlePingLogin()
      setLoginModal(true)
      return null
    } else {
      if (element?.action) {
        handleElementAction(element.action)
      } else {
        navigate(path)
      }
    }
  }

  useEffect(() => {
    if (needLogin(path) && (!userLoggedIn || getSV("anoLoginUUID"))) {
      setSelected(false)
      setDisabled(true)
    } else {
      setDisabled(false)
    }
    //eslint-disable-next-line
  }, [userLoggedIn, path, userData])

  useEffect(() => {
    if (path === "/" && location.pathname === "/") {
      setSelected(true)
    } else if (location.pathname !== "/") {
      path.includes(location.pathname) ? setSelected(true) : setSelected(false)
    } else {
      setSelected(false)
    }
  }, [path, location.pathname])

  return (
    <>
      <div
        className={`navIcon-root !pt-0  ${disabled ? "disabled" : "enabled"} ${selected ? "selected relative activeElement" : ""
          }`}
        onClick={handleClickOnNavIcon}
      >
        <div
          className={`${selected ? "!bg-secondary" : ""} navIcon-icon ${appParams?.styles?.borderRadius?.navBar || "rounded-full"
            }`}
          style={style}
        >
          <div className="w-6 h-6">
            <Icon
              name={icon}
              className={
                selected
                  ? "stroke-[var(--bottom-bar-selected-nav-text-color)]"
                  : "stroke-[var(--bottom-bar-nav-text-color)]"
              }
              secondClassName={
                selected
                  ? "fill-[var(--bottom-bar-selected-nav-text-color)]"
                  : "fill-[var(--bottom-bar-nav-text-color)]"
              }
            />
          </div>
        </div>
        {!appParams?.styles?.topBottomBar?.hideText && (
          <div className="navIcon-text">
            {text != null && getValue(text)}
            {(text == null || text === "") && getName(multiLangText)}
          </div>
        )}
      </div>
      {loginModal && (
        <LoginModal isOpen={loginModal} setIsOpen={setLoginModal} />
      )}
      <Modal
        isOpen={modalOpen}
        onOpenChange={setModalOpen}
        size="full"
        radius="none"
        className="bg-background"
        classNames={{
          base: "m-0 flex flex-col max-w-[820px] md:max-w-[500px]",
          wrapper: "sm:items-end",
          closeButton:
            "z-50 bg-[var(--button-bg-color)] text-[var(--button-text-color)]",
        }}
      >
        <ModalContent>
          {(onClose) => (
            <ModalBody className={"overflow-hidden"}>{modalContent}</ModalBody>
          )}
        </ModalContent>
      </Modal>
    </>
  )
}
